var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongRenwu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5a.5.5 0 010 1v-1zM13.5 8a.5.5 0 011 0h-1zm-11 5.5h11v1h-11v-1zm0-11v11h-1v-11h1zm5.5 0H2.5v-1H8v1zm5.5 11V8h1v5.5h-1zm-12-11a1 1 0 011-1v1h-1zm12 11h1a1 1 0 01-1 1v-1zm-11 1a1 1 0 01-1-1h1v1zM6.054 6.174a.6.6 0 00-.908.784l.908-.784zM7.874 9.2l-.454.392a.6.6 0 00.873.038l-.419-.43zm5.345-4.37a.6.6 0 10-.838-.86l.838.86zM5.146 6.958L7.42 9.592l.909-.784-2.275-2.634-.908.784zM8.293 9.63l4.926-4.8-.838-.86-4.925 4.8.837.86z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_renwu.85f9a211.svg";
export { SvgTongyongRenwu as ReactComponent };